package com.esoris.kmpmoout.features.product

import com.esoris.kmpmoout.navigation.AppRoute

sealed class ProductEvent {
    data class OnNavigateTo(val route: AppRoute) : ProductEvent()

    data class OnNameChange(val name: String) : ProductEvent()
    data class OnAddProduct(val name: String) : ProductEvent()
}